import { useMutation, useQueryClient } from "@tanstack/react-query";
import { z } from "zod/v4";

import { useProfile } from "./get-profile";
import { createUserRequestFromContacts, updateUser } from "./utils";

import type { MutationConfig } from "@/lib/react-query";
import type { User } from "@/types/user";

export const userSchema = z.object({
  email: z.string().optional(),
  phone_number: z.string().optional(),
});

export type UpdateContactsInput = z.infer<typeof userSchema>;

type UseUpdateContactsOptions = {
  mutationConfig?: MutationConfig<(data: UpdateContactsInput) => Promise<User>>;
};

export const useUpdateContacts = ({ mutationConfig }: UseUpdateContactsOptions = {}) => {
  const queryClient = useQueryClient();
  const { data: user } = useProfile();
  const createRequest = createUserRequestFromContacts(user);

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: (data) => updateUser(createRequest(data)),
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.setQueryData(["profile"], data);
      onSuccess?.(data, variables, onMutateResult, context);
    },
    ...restConfig,
  });
};
